export const selectIndexOptions = [
  {value: 'peIndex', label: 'P/E Индекса Мосбиржи'},
  {value: 'evEbitdaIndex', label: 'EV/EBITDA Индекса Мосбиржи'},
  {value: 'peSecondTier', label: 'P/E 2-3 эшелон'},
  {value: 'evEbitdaSecondTier', label: 'EV/EBITDA 2-3 эшелон'},
  {value: 'divYieldIndex', label: 'Дивдоходность IMOEX'},
  {value: 'divYieldSecondTier', label: 'Дивдоходность 2-3 эшелон'},
];

export const PERIOD_IDS = {
  "ONE_WEEK": "ONE_WEEK",
  "ONE_MONTH": "ONE_MONTH",
  "THREE_MONTH": "THREE_MONTH",
  "SIX_MONTH": "SIX_MONTH",
  "ONE_YEAR": "ONE_YEAR",
  "FIVE_YEAR": "FIVE_YEAR",
  "ALL": "ALL",
}

export const selectPeriodOptions = [
  {id: PERIOD_IDS.ONE_WEEK, name: '1 нед.'},
  {id: PERIOD_IDS.ONE_MONTH, name: '1 мес.'},
  {id: PERIOD_IDS.THREE_MONTH, name: '3 мес.'},
  {id: PERIOD_IDS.SIX_MONTH, name: '6 мес.'},
  {id: PERIOD_IDS.ONE_YEAR, name: '1 год'},
  {id: PERIOD_IDS.FIVE_YEAR, name: '5 лет'},
  {id: PERIOD_IDS.ALL, name: 'Все'},
];
